import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  PartnerFacilityVerificationSalesProcess
} from "../../../shared/interface/partner-facility-verification-sales-process";
import {AuthService} from "../../../shared/services/auth.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";

@Component({
  selector: 'app-verification-sales-process-view',
  templateUrl: './verification-sales-process-view.component.html',
  styleUrls: ['./verification-sales-process-view.component.scss']
})
export class VerificationSalesProcessViewComponent implements OnInit {
  @Input() partnerFacilityVerificationSalesProcess: PartnerFacilityVerificationSalesProcess;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;


  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
